import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "environments/environment";
import { TypeRegulation } from "../models";

@Injectable({providedIn: 'root'})
export class TypeRegulationService{

    constructor(private _htt: HttpClient){}

    getAll(){
        return this._htt.get<TypeRegulation[]>(`${environment.rydApiUrl}/api/type-regulation`);
    }
}
